import React from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";

export default class PEPFeedbackSummarySW extends MultiPageForm
{
	constructor(props)
	{
		super(props);

		if ( this.props.notes != null )
		{
			this.state.notes = this.props.notes ;
		}
		
		this.keyCount = 1 ;

		this.getPEPData ( this.props.pep_id ) ;
	}

	getFormData()
	{
		var data = {} ; 

		data.feedback = this.refs.InputNotes.getValue() ;

		return data ;
	}
	
	getPEPData ( pep_id ) 
	{
		let url = Globals.APIFolder + '/peps/' + pep_id  ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: url ,
    		  success:(data)=>{
				if ( data.status.result == 'success')
				{
					if ( data.data.child != null )
					{
						const child = data.data.child ;
						this.setState ({child_forename: child.firstname, child_surname: child.surname}) ;
					}
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
  		  }
    		});

	}
	
	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}	
		}
	}

	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}
	
	row1Content()
	{
		var lineList=[];
		
		var message = 'You have been invited to contribute to the PEP review for ' + this.state.child_forename + ' ' + this.state.child_surname + '  by their Education Support Worker' ;
		
		lineList.push ( React.createElement ( 'h3', {key: this.keyCount++}, 'Thank you for visiting the PEP feedback page')) ;
		lineList.push ( React.createElement ( 'h3', {key: this.keyCount++}, message)) ;		
		lineList.push ( React.createElement ( 'h3', {key: this.keyCount++}, "Please use the 'Next' and 'Previous' buttons below to navigate through the feedback forms and enter the data required.")) ;
		lineList.push ( React.createElement ( 'h3', {key: this.keyCount++}, "On the last screen, you will be able to submit your feedback for the student and your attendance, performance and feedback information will be incorporated into the pupil's PEP.")) ;
		
		return React.createElement ( 'div', { key: this.keyCount++, className: 'col-1 col-md-12'}, lineList) ;
	
	}
	
	
	formRow1 ()
    {
        return React.createElement ( 'div', { key: this.keyCount++, className: 'row'} , this.row1Content()) ;
    }

	
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.mode == 'view')
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Close')))

        }
        else
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onNext.bind(this) }, 'Next'),
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
        	
        }
           		        
        return React.createElement('div', { key: this.keyCount++ }, lineList );
    }


	formRows ()
	{
		var lineList=[];

        lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'row panel-body'},
    			React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'} , this.formRow1() )));

		lineList.push ( this.navFormRow());

		return lineList ;
	}
	
	render() 
    {
		this.keyCount=0;
        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default panel-noborder'}, this.formRows());
    }
};